import { render, staticRenderFns } from "./headlines-hot.vue?vue&type=template&id=5f02f3ae&scoped=true&"
import script from "./headlines-hot.vue?vue&type=script&lang=js&"
export * from "./headlines-hot.vue?vue&type=script&lang=js&"
import style0 from "./headlines-hot.vue?vue&type=style&index=0&id=5f02f3ae&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f02f3ae",
  null
  
)

export default component.exports